import { objectKeyValueArray, objectValues } from "./functions.js"

export const OPERATIONAL_STATUSES = {
    OPERATIONAL: 'operational',
    IN_MAINTENANCE: 'in_maintenance',
    UNDER_CONSTRUCTION: 'under_construction',
    CLOSED: 'closed'
};
export const OPERATIONAL_STATUSES_ENUM = objectValues(OPERATIONAL_STATUSES);
export const OPERATIONAL_STATUSES_AS_ARRAY = objectKeyValueArray(OPERATIONAL_STATUSES);

export const AVAILABILITY_STATUSES = {
    AVAILABLE: 'available',
    OCCUPIED: 'occupied',
    RESERVED: 'reserved',
    IN_MAINTENANCE: 'in_maintenance',
    BLOCKED: 'blocked',
};
export const AVAILABILITY_STATUSES_ENUM = objectValues(AVAILABILITY_STATUSES);

export const ASSIGNMENT_STATUSES = {
    PERMANENT: 'permanent',
    FLEXIBLE: 'flexible',
    HOT_DESK: 'hot_desk',
    TEMPORARY: 'temporary',
    DEFAULT: 'default'
};
export const ASSIGNMENT_STATUSES_ENUM = objectValues(ASSIGNMENT_STATUSES);


export const LEVELS = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
};
export const LEVELS_ENUM = objectValues(LEVELS);

export const VENTILATION_OPTIONS = {
    NATURAL: 'natural',
    AC: 'ac',
    BOTH: 'both'
};
export const VENTILATION_OPTIONS_ENUM = objectValues(VENTILATION_OPTIONS);

export const ACCOMMODATION_TYPES = {
    EXECUTIVE: 'executive',
    SOFA: 'sofa',
    COMMON: 'common',
    ERGONOMIC: 'ergonomic'
};
export const ACCOMMODATION_TYPES_ENUM = objectValues(ACCOMMODATION_TYPES);

export const DESK_TYPES = {
    FIXED: 'fixed',
    ADJUSTABLE: 'adjustable',
    STANDING: 'standing'
};
export const DESK_TYPES_ENUM = objectValues(DESK_TYPES);

export const SECURITY_TYPES = {
    FINGERPRINT: 'fingerprint',
    FACE_DETECTION: 'face_detection',
    SHARED_FINGERPRINT: 'shared_fingerprint'
};
export const SECURITY_TYPES_ENUM = objectValues(SECURITY_TYPES);

export const VERIFICATION_TYPES = {
    APPROVED: 'approved',
    PENDING: 'pending',
    REJECTED: 'rejected',
    NOTIFIED: 'notified',
    CANCELLED: 'cancelled',
    COMPLETED: 'completed'
};
export const VERIFICATION_TYPES_ENUM = objectValues(VERIFICATION_TYPES);

export const BUSINESS_LEADS = {
    NEW: 'new',
    CONTACTED: 'contacted',
    QUALIFIED: 'qualified',
    NEGOTIATING: 'negotiating',
    FOLLOW_UP: 'follow_up',
    REJECTED: 'rejected',
    COMPLETED: 'completed'
};
export const BUSINESS_LEADS_ENUM = objectValues(BUSINESS_LEADS);

export const EMAIL_SUBSCRIPTIONS = { // data usage permissions for sending emails
    MARKETING: 'marketing',
    SALES: 'sales',
    PRODUCT_UPDATES: 'product_updates',
    ANALYTICS: 'analytics',
    THIRD_PARTY_SHARING: 'third_party_sharing'
}
export const EMAIL_SUBSCRIPTIONS_ENUM = objectValues(EMAIL_SUBSCRIPTIONS);

export const MARKETING_CHANNELS = {
    WEBSITE: 'website',
    GOOGLE: 'google',
    LINKEDIN: 'linkedin',
    WALK_IN: 'walk_in',
    REFERRAL: 'referral',
    COLD_CALL: 'cold_call',
    OLD_CUSTOMER: 'old_customer',
    WHATSAPP: 'whatsapp',
    WEBINAR: 'webinar',
    SOCIAL_MEDIA: 'social_media',
    EMAIL_CAMPAIGN: 'email_campaign',
    PHONE: 'phone',
    ADVERTISEMENT: 'advertisement',
    OTHER: 'other'
};
export const MARKETING_CHANNELS_ENUM = objectValues(MARKETING_CHANNELS);

export const DEAL_STAGES = {
    NEW: 'new',
    CONTACTED: 'contacted',
    QUALIFIED: 'qualified',
    NEGOTIATING: 'negotiating',
    WON: 'won',
    // Open: leads that had some interaction but no final outcome — eligible for campaigns
    OPEN: 'open',
    // Do Not Contact: permanently opted-out leads (previously LOST)
    DO_NOT_CONTACT: 'do_not_contact',
    RECRUITMENT: 'recruitment',
};
export const DEAL_STAGES_ENUM = objectValues(DEAL_STAGES);

// ['email', 'phone', 'in_person', 'video_call', 'social_media', 'other']
export const CONTACT_TYPES = {
    EMAIL: 'email',
    PHONE: 'phone',
    IN_PERSON: 'in_person',
    SMS: 'sms',
    WHATSAPP: 'whatsapp',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    X: 'x',
    SOCIAL_MEDIA: 'social_media',
    OTHER: 'other'
};
export const CONTACT_TYPES_ENUM = objectValues(CONTACT_TYPES);

// ['strong', 'moderate', 'weak']
export const RELATIONSHIP_STRENGTHS = {
    STRONG: 'strong',
    MODERATE: 'moderate',
    WEAK: 'weak'
};
export const RELATIONSHIP_STRENGTHS_ENUM = objectValues(RELATIONSHIP_STRENGTHS);

// ['not_sent', 'sent', 'reviewing', 'accepted', 'rejected']
export const BUSINESS_LEAD_STATUS = {
    NOT_SENT: 'not_sent',
    SENT: 'sent',
    REVIEWING: 'reviewing',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected'
};
export const BUSINESS_LEAD_STATUS_ENUM = objectValues(BUSINESS_LEAD_STATUS);

// ['not_started', 'early_discussion', 'proposal_review', 'final_terms', 'contract_signed']
export const NEGOTIATION_STAGES = {
    NOT_STARTED: 'not_started',
    EARLY_DISCUSSION: 'early_discussion',
    PROPOSAL_REVIEW: 'proposal_review',
    FINAL_TERMS: 'final_terms',
    CONTRACT_SIGNED: 'contract_signed'
};
export const NEGOTIATION_STAGES_ENUM = objectValues(NEGOTIATION_STAGES);

//['1-10', '11-50', '51-200', '201-500', '501-1000', '1001-5000', '5001+']
export const COMPANY_SIZES = {
    MICRO: '1-10',
    SMALL: '11-50',
    MEDIUM: '51-200',
    LARGE: '201-500',
    XLARGE: '501-1000',
    XXLARGE: '1001-5000',
    XXXLARGE: '5001+'
};
export const COMPANY_SIZES_ENUM = objectValues(COMPANY_SIZES);

export const ANNUAL_REVENUES = {
    LESS_THAN_10M: 'PKR:10000000:<10M', // 10M
    FROM_10M_TO_100M: 'PKR:100000000:10M-100M', // 100M
    FROM_100M_TO_500M: 'PKR:500000000:100M-500M', // 500M
    FROM_500M_TO_1B: 'PKR:1000000000:500M-1B', // 1B
    FROM_1B_TO_5B: 'PKR:5000000000:1B-5B', // 5B
    FROM_5B_TO_10B: 'PKR:10000000000:5B-10B', // 10B
    GREATER_THAN_10B: 'PKR:X:10B+' // 50B
};
export const ANNUAL_REVENUES_ENUM = objectValues(ANNUAL_REVENUES);

export const DEAL_SIZES = {
    LESS_THAN_100K: 'PKR:100000:<100K', // less than 100K
    FROM_100K_TO_500K: 'PKR:500000:100K-500K', // 100K - 500K
    FROM_500K_TO_1M: 'PKR:1000000:500K-1M', // 500K - 1M
    FROM_1M_TO_5M: 'PKR:5000000:1M-5M', // 1M - 5M
    FROM_5M_TO_10M: 'PKR:10000000:5M-10M', // 5M - 10M
    FROM_10M_TO_50M: 'PKR:50000000:10M-50M', // 10M - 50M
    FROM_50M_TO_100M: 'PKR:100000000:50M-100M', // 50M - 100M
    FROM_100M_TO_500M: 'PKR:500000000:100M-500M', // 50M - 100M
    FROM_500M_TO_1B: 'PKR:1000000000:500M-1B', // 500M - 1B
    GREATER_THAN_1B: 'PKR:X:1B+', // 100M
};
export const DEAL_SIZES_ENUM = objectValues(DEAL_SIZES);

// ['immediate', '1-3 months', '3-6 months', '6-12 months', '12+ months']
export const SALES_CYCLE_LENGTHS = {
    IMMEDIATE: 'immediate',
    FROM_1_TO_3_DAYS: '1-3 Days',
    FROM_3_TO_6_DAYS: '3-7 Days',
    FROM_6_TO_12_DAYS: '7-15 Days',
    MORE_THAN_12_DAYS: '15+ Days',
};
export const SALES_CYCLE_LENGTHS_ENUM = objectValues(SALES_CYCLE_LENGTHS);

export const QUOTATION_STATUSES = {
    DRAFT: 'draft',
    SENT: 'sent',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    EXPIRED: 'expired'
};
export const QUOTATION_STATUSES_ENUM = objectValues(QUOTATION_STATUSES);

export const QUOTATION_UNITS = {
    SEAT: 'seat',
    OFFICE: 'office'
};
export const QUOTATION_UNITS_ENUM = objectValues(QUOTATION_UNITS);

export const CURRENCIES = {
    PKR: 'PKR',
    USD: 'USD',
    EUR: 'EUR',
    GBP: 'GBP',
    AED: 'AED'
};
export const CURRENCIES_ENUM = objectValues(CURRENCIES);

export const STATIC_USER_ROLES = {
    ADMIN: 'admin',
    MANAGER: 'manager',
    EMPLOYEE: 'employee',
    GUEST: 'guest',
    SUPER_ADMIN: 'super_admin',
    STAFF: 'staff', // Generic admin-side role — permissions come from dynamicRole
    USER: 'user',
    TEAM_MEMBER: 'team_member',
    RECEPTIONIST: 'receptionist',
    SUPPORT_AGENT: 'support_agent'
};
export const STATIC_USER_ROLES_ENUM = objectValues(STATIC_USER_ROLES);

export const CONNECTION_TYPES = {
    PERMANENT: 'permanent',
    TEMPORARY: 'temporary'
};
export const CONNECTION_TYPES_ENUM = objectValues(CONNECTION_TYPES);

export const DAY_PASS_TYPES = {
    NONE: 'none',
    SINGLE: 'single',
    RANDOM: 'random',
    DISCREET: 'discreet',
    MEETING_ROOM_ONLY: 'meeting_room_only',
};
export const DAY_PASS_TYPES_VALUES = objectValues(DAY_PASS_TYPES);
export const DAY_PASS_TYPES_ENUM = objectKeyValueArray(DAY_PASS_TYPES);

export const PRICE_TYPES = {
    HOURLY: 'hourly',
    DAILY: 'daily',
    MONTHLY: 'monthly',
};
export const PRICE_TYPES_ENUM = objectValues(PRICE_TYPES);

export const DAYS_OF_WEEK = {
    MONDAY: 'monday',
    TUESDAY: 'tuesday',
    WEDNESDAY: 'wednesday',
    THURSDAY: 'thursday',
    FRIDAY: 'friday',
    SATURDAY: 'saturday',
    SUNDAY: 'sunday'
};
export const DAYS_OF_WEEK_ENUM = objectValues(DAYS_OF_WEEK);

// Ticket categories are admin-configurable, not a fixed enum — fetch them with
// custom-hooks/use-support-categories.js instead of importing a constant.

// Distinct from LEVELS — support tickets need an Urgent tier that LEVELS doesn't have,
// and LEVELS is shared with Leads, Offices, CoWorking and Seats where "Urgent" is
// meaningless. Must mirror SUPPORT_TICKET_PRIORITIES in the backend enums exactly.
export const SUPPORT_TICKET_PRIORITIES = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    URGENT: 'urgent'
};
export const SUPPORT_TICKET_PRIORITIES_ENUM = objectValues(SUPPORT_TICKET_PRIORITIES);

export const INVENTORY_CATEGORIES = {
    BEVERAGES: 'beverages',
    PAPER_STATIONERY: 'paper_stationery',
    CLEANING: 'cleaning',
    KITCHENWARE: 'kitchenware',
    EQUIPMENT: 'equipment',
    OTHERS: 'others'
};
export const INVENTORY_CATEGORIES_ENUM = objectValues(INVENTORY_CATEGORIES);

export const INVENTORY_TRANSACTION_TYPES = {
    IN: 'in',
    OUT: 'out',
    BREAKAGE: 'breakage'
};
export const INVENTORY_TRANSACTION_TYPES_ENUM = objectValues(INVENTORY_TRANSACTION_TYPES);

export const MAINTENANCE_CATEGORIES = {
    REPAIR: 'repair',
    MAINTENANCE: 'maintenance',
    DECOR: 'decor',
    ENHANCEMENT: 'enhancement',
    NEW: 'new',
    OTHER: 'other'
};
export const MAINTENANCE_CATEGORIES_ENUM = objectValues(MAINTENANCE_CATEGORIES);

export const MAINTENANCE_STATUSES = {
    TODO: 'todo',
    IN_PROGRESS: 'in_progress',
    ON_HOLD: 'on_hold',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled'
};
export const MAINTENANCE_STATUSES_ENUM = objectValues(MAINTENANCE_STATUSES);

export const MAINTENANCE_PRIORITIES = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    URGENT: 'urgent'
};
export const MAINTENANCE_PRIORITIES_ENUM = objectValues(MAINTENANCE_PRIORITIES);

export const SUPPORT_TICKET_STATUSES = {
    OPEN: 'open',
    AWAITING_APPROVAL: 'awaiting_approval',
    IN_PROGRESS: 'in_progress',
    PENDING_CUSTOMER: 'pending_customer',
    RESOLVED: 'resolved',
    CLOSED: 'closed',
    CANCELLED: 'cancelled'
};
export const SUPPORT_TICKET_STATUSES_ENUM = objectValues(SUPPORT_TICKET_STATUSES);

export const SUPPORT_TICKET_CUSTOMER_ACKNOWLEDGMENT_STATUSES = {
    PENDING: 'pending',
    ACKNOWLEDGED: 'acknowledged',
    DISPUTED: 'disputed'
};
export const SUPPORT_TICKET_CUSTOMER_ACKNOWLEDGMENT_STATUSES_ENUM = objectValues(SUPPORT_TICKET_CUSTOMER_ACKNOWLEDGMENT_STATUSES);

export const SUPPORT_TICKET_NOTIFICATION_TYPES = {
    TICKET_CREATED: 'ticket_created',
    STATUS_UPDATED: 'status_updated',
    AGENT_ASSIGNED: 'agent_assigned',
    NEW_MESSAGE: 'new_message',
    RESOLVED_PENDING_ACK: 'resolved_pending_ack',
    AUTO_CLOSE_WARNING: 'auto_close_warning',
    TICKET_CLOSED: 'ticket_closed',
    ESCALATION_ALERT: 'escalation_alert',
    SLA_BREACH_WARNING: 'sla_breach_warning'
}
export const SUPPORT_TICKET_NOTIFICATION_TYPES_ENUM = objectValues(SUPPORT_TICKET_NOTIFICATION_TYPES);

export const NOTIFICATION_DELIVERY_METHODS = {
    IN_APP: 'in_app',
    EMAIL: 'email',
    BROWSER_NOTIFICATION: 'browser_notification'
}
export const NOTIFICATION_DELIVERY_METHODS_ENUM = objectValues(NOTIFICATION_DELIVERY_METHODS);

export const NOTIFICATION_STATUSES = {
    PENDING: 'pending',
    SENT: 'sent',
    FAILED: 'failed',
    READ: 'read',
    SEEN: 'seen'
}
export const NOTIFICATION_STATUSES_ENUM = objectValues(NOTIFICATION_STATUSES);

export const NOTIFICATION_PRIORITY = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    URGENT: 'urgent'
}
export const NOTIFICATION_PRIORITY_ENUM = objectValues(NOTIFICATION_PRIORITY);

export const SUPPORT_TICKET_INTERACTION_TYPES = {
    NOTE: 'note',
    EMAIL: 'email',
    PHONE: 'phone',
    CHAT: 'chat',
    INTERNAL_NOTE: 'internal_note',
    STATUS_CHANGE: 'status_change',
    PRIORITY_CHANGE: 'priority_change',
    ASSIGNMENT: 'assignment'
}
export const SUPPORT_TICKET_INTERACTION_TYPES_ENUM = objectValues(SUPPORT_TICKET_INTERACTION_TYPES);

export const SUPPORT_TICKET_INTERACTION_VISIBILITY = {
    CUSTOMER: 'customer',
    AGENT: 'agent',
    INTERNAL: 'internal'
}
export const SUPPORT_TICKET_INTERACTION_VISIBILITY_ENUM = objectValues(SUPPORT_TICKET_INTERACTION_VISIBILITY);


export const COLORS = {
    primary: "#ffa726",
    secondary: "#000000",
    success: "#8bc34a",
    error: "#f44336", // red
    info: "#2196f3",
    warning: "#ffc107",
    light: "#f5f5f5",
    dark: "#212121",
    muted: "#6c757d",
}

export const HOURLY_TIME_SLOTS = {
    "00:00": "12:00 AM",
    "01:00": "01:00 AM",
    "02:00": "02:00 AM",
    "03:00": "03:00 AM",
    "04:00": "04:00 AM",
    "05:00": "05:00 AM",
    "06:00": "06:00 AM",
    "07:00": "07:00 AM",
    "08:00": "08:00 AM",
    "09:00": "09:00 AM",
    "10:00": "10:00 AM",
    "11:00": "11:00 AM",
    "12:00": "12:00 PM",
    "13:00": "01:00 PM",
    "14:00": "02:00 PM",
    "15:00": "03:00 PM",
    "16:00": "04:00 PM",
    "17:00": "05:00 PM",
    "18:00": "06:00 PM",
    "19:00": "07:00 PM",
    "20:00": "08:00 PM",
    "21:00": "09:00 PM",
    "22:00": "10:00 PM",
    "23:00": "11:00 PM"
}
export const HOURLY_TIME_SLOTS_ENUM = objectKeyValueArray(HOURLY_TIME_SLOTS);

export const DAY_PASSES_TYPES = {
    HOURLY: 'hourly',
    DAILY: 'daily',
    MONTHLY_RECURRING: 'monthly_recurring'
};
export const DAY_PASSES_TYPES_ENUM = objectKeyValueArray(DAY_PASSES_TYPES);

export const PAYMENT_STATUS = {
    PENDING: 'pending',
    PAID: 'paid',
    FAILED: 'failed',
    REFUNDED: 'refunded'
};
export const PAYMENT_STATUS_ENUM = objectKeyValueArray(PAYMENT_STATUS);

export const PAYMENT_METHODS = {
    CASH: 'cash',
    BANK_TRANSFER: 'bank_transfer',
    SECURITY_ADJUSTMENT: 'security_adjustment',
};
export const PAYMENT_METHODS_ENUM = objectKeyValueArray(PAYMENT_METHODS);

export const BANK_TRANSFER_TYPES = {
    ONLINE: 'online',
    CHEQUE: 'cheque',
};
export const BANK_TRANSFER_TYPES_ENUM = objectKeyValueArray(BANK_TRANSFER_TYPES);

// ** ------------------------------------- Invoice enums
export const INVOICE_STATUSES = {
    DRAFT: 'draft',
    DELIVERED: 'delivered',
    PARTIALLY_PAID: 'partially_paid',
    PAID: 'paid',
    VOID: 'void',
};
export const INVOICE_STATUSES_ENUM = objectKeyValueArray(INVOICE_STATUSES);

export const INVOICE_LINE_ITEM_TYPES = {
    SEAT_BOOKING: 'seat_booking',
    OFFICE_BOOKING: 'office_booking',
    DAY_PASS: 'day_pass',
    SECURITY_DEPOSIT: 'security_deposit',
    ADVANCE_DEDUCTION: 'advance_deduction',
    EXTENSION_FEE: 'extension_fee',
    OTHER: 'other',
};
export const INVOICE_LINE_ITEM_TYPES_ENUM = objectKeyValueArray(INVOICE_LINE_ITEM_TYPES);

// ** ------------------------------------- Refund enums
export const REFUND_TYPES = {
    SECURITY_DEPOSIT: 'security_deposit',
    DAY_PASS: 'day_pass',
    OTHER: 'other',
};
export const REFUND_TYPES_ENUM = objectKeyValueArray(REFUND_TYPES);

export const REFUND_STATUSES = {
    PENDING: 'pending',
    PROCESSED: 'processed',
    CANCELLED: 'cancelled',
};
export const REFUND_STATUSES_ENUM = objectKeyValueArray(REFUND_STATUSES);